import { useState } from "react";
import NormalButton from "../components/Button/NormalButton";
import HomeCard from "./HomeCard";
import { useUser } from "./provider/UserAuthProvider";
import Space from "./Space";
import AlertDialog from "../components/Dialog/AlertDialog";
import { useTranslation } from "react-i18next";

function GuideCard() {
  const user = useUser();
  const [appleSignInFailed, setAppleSignInFailed] = useState({ show: false, message: "" });
  const { t } = useTranslation();

  return (
    <>
      {appleSignInFailed.show && (
        <AlertDialog
          title={t("tips")}
          text={t("apple_sign_in_failed", { error: appleSignInFailed.message })}
          positiveText={t("ok")}
          onPositive={() => {
            setAppleSignInFailed({ show: false, message: "" });
          }}
        />
      )}
      <HomeCard title={`📖 ${t("useage_guide")}`} subTitle={t("step")}>
        <div className="flex flex-col gap-[16px]">
          <Step number={"1"}>
            <div className="text-primary text-[16px]">
              {t("step_1")} <strong>{t("appName")}</strong>
            </div>
          </Step>
          <Step number={"2"}>
            <div className="text-primary text-[16px]">{t("setp_2")}</div>
          </Step>
          <Step number={"3"}>
            <div className="text-primary text-[16px]">{t("select_device_in_list")}</div>
          </Step>
        </div>
        <Space height="30px" />
        <div className="flex flex-col gap-[10px] items-start">
          <SubTitle text={t("question_1")} />
          <div className="text-primary text-[14px]">{t("answer_1")}</div>
        </div>
        <Space height="20px" />
        <div className="flex flex-col gap-[10px] items-start">
          <SubTitle text={t("question_2")} />
          <NormalButton
            text={t("download_app")}
            onClick={() => {
              window.open("https://xiaolifaa.com", "_blank");
            }}
          />
        </div>
        <Space height="20px" />
        <div className="flex flex-col gap-[10px] items-start">
          <SubTitle text={t("question_3")} />
          <div className="text-primary text-[14px]">{t("answer_3")}</div>
          {!user.user && (
            <div className="flex flex-row gap-[10px]">
              <NormalButton
                className={"wechat-signin-button"}
                text={t("sign_in_with_wechat")}
                onClick={() => {
                  const callbackUrl = `${window.location.origin}/login_callback`;
                  window.location.href = `https://xiaolifaa.com/fsend/user/website_login_with_wechat_qr_code?callbackUrl=${encodeURIComponent(
                    callbackUrl
                  )}`;
                }}
              />

              <NormalButton
                className={"apple-signin-button"}
                text={t("sign_in_with_apple")}
                onClick={async () => {
                  try {
                    const response = await window.AppleID.auth.signIn();
                    console.log("Apple Sign-In Success:", response);
                    const idToken = response.authorization.id_token;
                    const fullName = response.user
                      ? response.user.name.firstName + " " + response.user.name.lastName
                      : null;

                    // 处理成功响应，例如发送 authorizationCode 到服务器进行验证
                    await user.loginWithApple({ identityToken: idToken, fullName: fullName });
                  } catch (error) {
                    if (error.error !== "popup_closed_by_user") {
                      setAppleSignInFailed({ show: true, message: error.message });
                    }
                    console.error("Apple Sign-In Error:", error);
                  }
                }}
              />
            </div>
          )}
        </div>
      </HomeCard>
    </>
  );
}

function Step({ number, children }) {
  return (
    <div className="flex flex-row items-center justify-start gap-[6px]">
      <div className="flex items-center justify-center rounded-full w-[24px] h-[24px] bg-brand text-onBrand text-[14px] flex-shrink-0">
        {number}
      </div>
      {children}
    </div>
  );
}

function SubTitle({ text }) {
  return <div className="text-secondary font-bold text-[14px]">{text}</div>;
}

export default GuideCard;
